import { useState } from "react";
import { useI18n } from "../contexts/I18nContext";
import { Mail, Send } from "lucide-react";
import { toast } from "sonner";

const SUPPORT_EMAIL = "support@stopchlamas.lt";

export default function Contact() {
  const { t } = useI18n();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const onSubmit = (e) => {
    e.preventDefault();
    if (!message.trim()) return;
    // Open user's mail client with prefilled content (no backend route needed for now).
    const subject = encodeURIComponent(`[StopChlamas] ${name || "Kontaktas"}`);
    const body = encodeURIComponent(`${message}\n\n— ${name || ""} ${email ? `<${email}>` : ""}`);
    window.location.href = `mailto:${SUPPORT_EMAIL}?subject=${subject}&body=${body}`;
    toast.success(t("contact_sent"));
    setName(""); setEmail(""); setMessage("");
  };

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12" data-testid="contact-page">
      <h1 className="text-4xl sm:text-5xl font-heading font-black tracking-tight text-[#1A1A18]">
        {t("contact_title")}
      </h1>
      <p className="mt-3 text-base text-[#4A4A45] max-w-2xl">{t("contact_intro")}</p>

      <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="p-5 border border-[#D1CFC7] rounded-md bg-[#F7F6F2]" data-testid="contact-info">
          <div className="flex items-center gap-2 text-[#C85A32]">
            <Mail className="w-5 h-5" />
            <p className="font-heading font-bold text-sm uppercase tracking-widest">
              {t("contact_email")}
            </p>
          </div>
          <a
            href={`mailto:${SUPPORT_EMAIL}`}
            data-testid="contact-email-link"
            className="block mt-3 text-lg font-heading font-bold text-[#1A1A18] hover:text-[#C85A32] break-all"
          >
            {SUPPORT_EMAIL}
          </a>
          <p className="mt-3 text-sm text-[#7A7A73]">{t("contact_response")}</p>
        </div>

        <form onSubmit={onSubmit} className="space-y-3" data-testid="contact-form">
          <input
            data-testid="contact-name"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder={t("contact_form_name")}
            className="w-full bg-white border border-[#D1CFC7] rounded-md px-4 py-3 outline-none focus:ring-2 focus:ring-[#C85A32]"
          />
          <input
            data-testid="contact-email-input"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder={t("contact_form_email")}
            className="w-full bg-white border border-[#D1CFC7] rounded-md px-4 py-3 outline-none focus:ring-2 focus:ring-[#C85A32]"
          />
          <textarea
            data-testid="contact-message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder={t("contact_form_message")}
            rows={5}
            required
            className="w-full bg-white border border-[#D1CFC7] rounded-md px-4 py-3 outline-none focus:ring-2 focus:ring-[#C85A32]"
          />
          <button
            type="submit"
            data-testid="contact-submit"
            className="btn-primary w-full inline-flex items-center justify-center gap-2"
          >
            <Send className="w-4 h-4" /> {t("contact_form_send")}
          </button>
        </form>
      </div>
    </div>
  );
}
